const initialState = {
    carts: [],
    totalPrice: 0,
};
const shoppingCart = (state = initialState, action) => {
    var total_price = 0;
    switch (action.type) {
        case 'ACTION_ADD_TO_SHOPPING_CART':
            const {product, selectedVariant, seller, sku, title, number, image, price, priceSeparate, marketPrice, marketPriceSeparate, slug} = action.data; // gereftane etela@e mahsool
            const currentCartItem = {product, selectedVariant, seller, sku, title, number, image, price, priceSeparate, marketPrice, marketPriceSeparate, slug}; // amade kardane objecte mahsool jahate zakhire sazi ya taghirat
            const addCart = [...state.carts]; // cart items before added or updated new row

            total_price = state.totalPrice; // total price before added or updated new row
            // total_price = 0;

            if(addCart.length !== 0) {
                let finded = false;
                addCart.forEach(cart => {
                    if(cart.sku === action.data.sku && cart.seller.id === action.data.seller.id) {
                        

                        total_price -= (cart.number * parseInt(cart.price));
                        cart.number = number;
                        total_price += (number * parseInt(cart.price));

                        finded = true;
                    }
                    // else 
                    //     total_price += (number * parseInt(ourPrice));
                });
                if(! finded) {
                    addCart.push(currentCartItem);
                    total_price += (number * parseInt(price));
                }
            }
            else {
                addCart.push(currentCartItem);
                total_price += (number * parseInt(price));
            }


            return {...state, carts:  addCart, totalPrice: (total_price < 0 ? 0 : total_price)};
        case 'ACTION_REMOVE_FROM_SHOPPING_CART':
            let new_carts = [];
            total_price = 0;
        	if (state.carts.length !== 0) {
        		state.carts.forEach(product => {
        			if(product.sku !== action.data.sku || product.seller.id !== action.data.seller.id) {
        				new_carts.push(product);
                        total_price += (product.number * parseInt(product.price));
                    }
	            });
        	}
            return {...state, carts:  new_carts, totalPrice: (total_price < 0 ? 0 : total_price)};
        case 'ACTION_REMOVE_ALL_ITEM_IN_CART':
            return {...state, carts: [], totalPrice: 0};
        default:
            return state;
    }
};

export default shoppingCart;
